@if(isLoading){
<div   class="position-relative">
  <img 
      src="assets/images/bookcover/noimage.jpg"
      [alt]="'Homepicture'"
      [class]="cssStyle + ' cover'"
    
    />

    <span 
      class="position-absolute top-50 start-50 translate-bookcover z-1 text-wrap text-bookcover text-end"
    >
    Loading...
    </span>
</div>
}@else{
<div   class="position-relative">


  <img
      [src]="cover"
      [alt]="'Homepicture'"
      [class]="cssStyle + ' cover'"
      (error)="imagerror($event)"
    />
    <span *ngIf="checkNoImage()"
      class="position-absolute top-50 start-50 translate-bookcover z-1 text-wrap text-bookcover text-end"
    >
      {{title}}
    </span>
</div>
}

  
